import { render, staticRenderFns } from "./modifyPassword.vue?vue&type=template&id=537c0ebf&scoped=true&"
import script from "./modifyPassword.vue?vue&type=script&lang=js&"
export * from "./modifyPassword.vue?vue&type=script&lang=js&"
import style0 from "./modifyPassword.vue?vue&type=style&index=0&id=537c0ebf&scoped=true&lang=scss&"
import style1 from "./modifyPassword.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537c0ebf",
  null
  
)

export default component.exports